<template>
  <v-container>
    <v-card color="primary" class="rounded-xxl py-16 px-10">
      <v-card class="pt-7 pb-16" color="#fff">
        <v-row class="px-6">
          <v-col cols="12">
            <v-text-field
                @input="searchFunc"
                v-model="filterSearch.search"
                clearable
                class="rounded-lg pr-0 sm-font400-14"
                solo
                append-icon="mdi-magnify"
                placeholder="جستجو"
                single-line
                hide-details
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
                class="sm-font400-13 textTable--text"
                :headers="headers"
                :items="items"
                hide-default-footer
                no-results-text="دیتایی وجود ندارد!"
                :loading="loading"
                loading-text="Loading..."
                item-key="id"
                show-select
                v-model="ids"
            >
              <template v-slot:[`item.image`]="{ item }">
                <img
                    width="32"
                    height="32"
                    v-if="item.image"
                    :src="item.image"
                    class="ml-2 rounded-circle"
                    alt=""
                />
              </template>
              <template v-slot:[`item.username`]="{ item }">
                <div>{{ item.first_name }} {{ item.last_name }}</div>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                v-model="filterSearch.page"
                :length="totalPages"
                @input="getData"
                color="thirdColor"
            ></v-pagination>
          </v-col>
          <v-col></v-col>
        </v-row>
        <v-row justify="end" class="px-6">
          <v-col cols="3">
            <v-btn
                block
                :to="`/courses/class/users/${$route.params.id}`"
                outlined
                color="thirdColor"
                class="rounded-xl sm-font400-13"
                xelevation="2"
                height="48"
            >بازگشت
            </v-btn>
          </v-col>
          <v-col cols="3">
            <v-btn
                block
                color="positive"
                @click="addUserToClass"
                class="white--text rounded-xl sm-font400-13"
                xelevation="2"
                height="48"
            >افزودن کاربر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-card>
  </v-container>
</template>
<script>
import courses from "@/Services/modules/courses";

export default {
  name: "userAdd",
  data() {
    return {
      headers: [
        {text: "پروفایل", value: "image"},
        {text: "نام و نام‌ خانوادگی", value: "username"},
        {text: "ایمیل", value: "email"},
        {text: "شماره تماس", value: "phone_number"},
      ],
      items: [],
      ids: [],
      totalPages: 1,
      loading: false,
      filterSearch: {
        is_student: true,
        page: Number(this.$route.query.page) || 1,
        search: this.$route.query.search || "",
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      courses.getNotStudentRegister(this.$route.params.id, this.filterSearch).then(res => {
        this.items = res.data.results
        this.totalPages = res.data.page_count
      })
    },
    searchFunc() {
      this.$router.push({
        query: {
          ...this.$route.query,
          search: this.filterSearch.search
        }
      })
      this.getData()
    },
    addUserToClass() {
      let ids = [];
      this.ids.forEach((item) => {
        ids.push(item.id);
      });
      courses.addClassStudents(this.$route.params.id, {user_ids: ids}).then(() => {
        this.$router.push(`/courses/class/users/${this.$route.params.id}`)
      })
    }
  }
}
</script>
<style scoped>

</style>
